var React = require('react');

function IconFlickrInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5,0C7.387,0,0,7.387,0,16.5C0,25.613,7.387,33,16.5,33C25.613,33,33,25.613,33,16.5C33,7.387,25.613,0,16.5,0z\r\n\t M10.875,20.75c-2.295,0-4.156-1.86-4.156-4.156c0-2.295,1.861-4.156,4.156-4.156s4.156,1.861,4.156,4.156\r\n\tC15.031,18.89,13.17,20.75,10.875,20.75z M22.125,20.75c-2.295,0-4.156-1.86-4.156-4.156c0-2.295,1.861-4.156,4.156-4.156\r\n\ts4.156,1.861,4.156,4.156C26.281,18.89,24.42,20.75,22.125,20.75z"}));
}

IconFlickrInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"33px","height":"33px","viewBox":"0 0 33 33","enableBackground":"new 0 0 33 33","xmlSpace":"preserve"};

module.exports = IconFlickrInline;

IconFlickrInline.default = IconFlickrInline;
